module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-decoration-arc-282e18807cfb89f9fe8f6b6ba1fb3a99.png";